import React from "react";
import Filter from "../Filter/Filter";

function Main() {
    return (
        <main className="page-main">
            <Filter />
        </main>
    );
}

export default Main;
